import React, { useContext, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { LocationContext } from '../Context/Location';

const restaurantUrl = 'https://zomatourl.herokuapp.com/restaurants?state_id='

const Wallpaper = () => {
  const {locations} = useContext(LocationContext)
  const [restaurants, setRestaurants] = useState([])
  const Navigate = useNavigate();

  const getRestaurant = (event) => {
    fetch(`${restaurantUrl}${event.target.value}`, {method : "GET"})
    .then(res => res.json())
    .then(data => {
      setRestaurants(data)
    })
    .catch(err => {
      console.log(err);
    })
  }

  const detailHandle = (event) => {
    // console.log(event.target.value);
    Navigate(`detail/${event.target.value}`)
  }

  return (
    <React.Fragment>
      <Container fluid className='bg-wallpaper'>
        <h1 className='w-logo'>E!</h1>
        <div className='w-title'>Find the best restaurants, cafés, and bars</div>
        <Row className='selection '>
          <Col sm={12} md={{span:3, offset : 2}}>
            <select name="location" id="location" className='location w-100 p-2 mb-2' onChange={getRestaurant}>
              <option>Select Location</option>
              {locations.map((location, index) => {
                return(
                  <option value={location.state_id} key={index} >{location.state}</option>
                )
              })}
            </select>
          </Col>
          <Col sm={12} md={5}>
            <select name="restaurant" id="restaurant" className='restaurant w-100 p-2' onChange={detailHandle}>
              <option >Select Restaurant</option>
              {
                restaurants.map((restaurant,index) => {
                  return(
                    <option value={restaurant.restaurant_id} key={index}>{restaurant.address}</option>
                  )
                })
              }
            </select>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default Wallpaper